module.exports = __webpack_public_path__ + "img/VerySad_1.c3376c96.png";